import {searchToObject} from "./filter_utils";

const parseUrl = function () {
  if ((typeof history === 'undefined' || history === null) || !window.location) {
    return;
  }

  const obj = searchToObject(window.location.search);
  if (obj['types'] != null) { obj.types = obj['types'].split(',').map(Number); }
  return obj;
}

const updateUrl = function (filters, pageNum, resetPageNum = false) {
  if (window.isMobileDevice) return;
  let filter;
  let object = {};
  const oldString = window.location.search + window.location.hash;
  let newString = '';

  for (filter in filters) {
    if (filters[filter]) {
      if (filters[filter] instanceof Array && (filters[filter].length > 0)) {
        object[filter] = filters[filter].join(',');
      } else if (filters[filter].toString() !== '') {
        object[filter] = filters[filter];
      }
    }
  }

  if (!resetPageNum) object['page'] = pageNum + 1;

  for (filter in object) {
    newString += newString.length > 2 ? '&' : '';
    const value = object[filter];
    newString += `${filter}=${value}`;
  }

  if (newString[0] === '&') newString = newString.slice(1);

  newString = newString === '' ? window.location.pathname : `${window.location.pathname}?${newString}`;

  if (newString !== oldString) {
    object.string = newString;
    history.pushState(object, document.title, newString);
  }
}

const waterFiltersCount = function (filters) {
  return filters.types?.length ?? 0;
}

export {parseUrl, updateUrl, waterFiltersCount}

